import { render, staticRenderFns } from "./itinerary.vue?vue&type=template&id=6b8338ca&scoped=true"
import script from "./itinerary.vue?vue&type=script&lang=js"
export * from "./itinerary.vue?vue&type=script&lang=js"
import style0 from "./itinerary.vue?vue&type=style&index=0&id=6b8338ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8338ca",
  null
  
)

export default component.exports